/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import { FormattedMessage } from 'react-intl';

const Day1 = [
  {
    left: {
      edmontionTime: '8:00 PM',
      chinaTime: '10:00 AM'
    },
    right: {
      state: true,
      description: <FormattedMessage id="Opening" />
    }
  },
  {
    left: {
      edmontionTime: '8:00 PM-8:20 PM',
      chinaTime: '10:00 AM-10:20 AM'
    },
    right: {
      img: true,
      description: (
        <>
          <div>
            <FormattedMessage id="ConferenceContent1_4" />
          </div>
          <div>
            <FormattedMessage id="ConferenceContent1_1" />
          </div>
          <div>
            <FormattedMessage id="ConferenceContent1_2" />
          </div>
          <div>
            <FormattedMessage id="ConferenceContent1_3" />
          </div>
        </>
      )
    }
  },
  {
    left: {
      freeTime: <FormattedMessage id="FreeTime" />
    },
    right: {
      state: true,
      description: <FormattedMessage id="Rest" />
    }
  },
  {
    left: {
      edmontionTime: '8:25 PM-9:10 PM',
      chinaTime: '10:25 AM-11:10 AM'
    },
    right: {
      img: true,
      description: (
        <>
          <div>
            <FormattedMessage id="ConferenceContent2_1" />
          </div>
          <div>
            <FormattedMessage id="ConferenceContent2_2" />
          </div>
        </>
      )
    }
  },
  {
    left: {
      freeTime: <FormattedMessage id="FreeTime" />
    },
    right: {
      state: true,
      description: <FormattedMessage id="Rest" />
    }
  },
  {
    left: {
      edmontionTime: '9:15 PM-10:00 PM',
      chinaTime: '11:15 AM-12:00 AM'
    },
    right: {
      img: true,
      description: (
        <>
          <div>
            <FormattedMessage id="ConferenceContent3_1" />
          </div>
          <div>
            <FormattedMessage id="ConferenceContent3_3" />
          </div>
          <div>
            <FormattedMessage id="ConferenceContent3_2" />
          </div>
        </>
      )
    }
  }
];
const Day2 = [
  {
    left: {
      edmontionTime: '8:00 PM',
      chinaTime: '10:00 AM'
    },
    right: {
      state: true,
      description: <FormattedMessage id="Opening" />
    }
  },
  {
    left: {
      edmontionTime: '8:00 PM-8:20 PM',
      chinaTime: '10:00 AM-10:20 AM'
    },
    right: {
      img: true,
      description: (
        <>
          <div>
            <FormattedMessage id="ConferenceContent4_1" />
          </div>
          <div>
            <FormattedMessage id="ConferenceContent4_2" />
          </div>
        </>
      )
    }
  },
  {
    left: {
      freeTime: <FormattedMessage id="FreeTime" />
    },
    right: {
      state: true,
      description: <FormattedMessage id="Rest" />
    }
  },
  {
    left: {
      edmontionTime: '8:25 PM-9:10 PM',
      chinaTime: '10:25 AM-11:10 AM'
    },
    right: {
      img: true,
      description: (
        <>
          <div>
            <FormattedMessage id="ConferenceContent5_1" />
          </div>
          <div>
            <FormattedMessage id="ConferenceContent5_2" />
          </div>
        </>
      )
    }
  },
  {
    left: {
      freeTime: <FormattedMessage id="FreeTime" />
    },
    right: {
      state: true,
      description: <FormattedMessage id="Rest" />
    }
  },
  {
    left: {
      edmontionTime: '9:15 PM-10:00 PM',
      chinaTime: '11:15 AM-12:00 AM'
    },
    right: {
      img: true,
      description: (
        <>
          <div>
            <FormattedMessage id="ConferenceContent6_1" />
          </div>
          <div>
            <FormattedMessage id="ConferenceContent6_3" />
          </div>
          <div>
            <FormattedMessage id="ConferenceContent6_2" />
          </div>
        </>
      )
    }
  }
];
const Day3 = [
  {
    left: {
      edmontionTime: '8:00 PM',
      chinaTime: '10:00 AM'
    },
    right: {
      state: true,
      description: <FormattedMessage id="Opening" />
    }
  },
  {
    left: {
      edmontionTime: '8:00 PM-8:20 PM',
      chinaTime: '10:00 AM-10:20 AM'
    },
    right: {
      img: true,
      description: (
        <>
          <div>
            <FormattedMessage id="ConferenceContent7_1" />
          </div>
          <div>
            <FormattedMessage id="ConferenceContent7_3" />
          </div>
          <div>
            <FormattedMessage id="ConferenceContent7_2" />
          </div>
        </>
      )
    }
  },
  {
    left: {
      freeTime: <FormattedMessage id="FreeTime" />
    },
    right: {
      state: true,
      description: <FormattedMessage id="Rest" />
    }
  },
  {
    left: {
      edmontionTime: '8:25 PM-9:10 PM',
      chinaTime: '10:25 AM-11:10 AM'
    },
    right: {
      img: true,
      description: (
        <>
          <div>
            <FormattedMessage id="ConferenceContent8_1" />
          </div>
          <div>
            <FormattedMessage id="ConferenceContent8_2" />
          </div>
        </>
      )
    }
  },
  {
    left: {
      freeTime: <FormattedMessage id="FreeTime" />
    },
    right: {
      state: true,
      description: <FormattedMessage id="Rest" />
    }
  },
  {
    left: {
      edmontionTime: '9:15 PM-10:00 PM',
      chinaTime: '11:15 AM-12:00 AM'
    },
    right: {
      img: true,
      description: (
        <>
          <div>
            <FormattedMessage id="ConferenceContent9_1" />
          </div>
          <div>
            <FormattedMessage id="ConferenceContent9_3" />
          </div>
          <div>
            <FormattedMessage id="ConferenceContent9_2" />
          </div>
        </>
      )
    }
  }
];
const Day4 = [
  {
    left: {
      edmontionTime: '8:00 PM',
      chinaTime: '10:00 AM'
    },
    right: {
      state: true,
      description: <FormattedMessage id="Opening" />
    }
  },
  {
    left: {
      edmontionTime: '8:00 PM-8:40 PM',
      chinaTime: '10:00 AM-10:40 AM'
    },
    right: {
      img: true,
      description: (
        <div>
          <FormattedMessage id="ConferenceContent10" />
          <p>
            <FormattedMessage id="ConferenceContent10_1" />
          </p>
          <p>
            <FormattedMessage id="ConferenceContent10_2" />
          </p>
          <p>
            <FormattedMessage id="ConferenceContent10_3" />
          </p>
          <p>
            <FormattedMessage id="ConferenceContent10_4" />
          </p>
        </div>
      )
    }
  },
  {
    left: {
      edmontionTime: '8:40 PM-10:00 PM',
      chinaTime: '10:40 AM-12:00 AM'
    },
    right: {
      img: true,
      description: (
        <>
          <div>
            <FormattedMessage id="ConferenceContent11_1" />
          </div>
          <div>
            <FormattedMessage id="ConferenceContent11_2" />
          </div>
        </>
      )
    }
  }
];

const Button1 = {
  name: 'day1',
  className: 'Conference-btn-one'
};
const Button2 = {
  name: 'day2',
  className: 'Conference-btn-two'
};
const Button3 = {
  name: 'day3',
  className: 'Conference-btn-three'
};
const Button4 = {
  name: 'day4',
  className: 'Conference-btn-four'
};
export { Day1, Day2, Day3, Day4, Button1, Button2, Button3, Button4 };
